export const getElementPosition = (target) => {
    const element = target;
    const offsetX = element.offsetLeft;
    const { width } = element.getBoundingClientRect();
    return {
        offsetX,
        width,
    };
};
//# sourceMappingURL=base-control.util.js.map